// Shared Naija character appearance config — keys stored on the character,
// visuals resolved here + in NaijaAvatar.jsx. Kept in sync with backend game_data APPEARANCE.

export const SKINS = {
  s0: { fill: "#C68C5E", dark: "#A9714A" },
  s1: { fill: "#A96B3C", dark: "#8A5730" },
  s2: { fill: "#8B5A2B", dark: "#6F4722" },
  s3: { fill: "#6B4323", dark: "#54341B" },
  s4: { fill: "#4E2E18", dark: "#3A2212" },
};

export const HAIR_COLORS = {
  black: "#1A1512",
  brown: "#3B2412",
  auburn: "#5E2A10",
  blonde: "#C9A24B",
  red: "#7A1F12",
  platinum: "#D8D2C2",
};

export const OUTFIT_COLORS = {
  green: "#16A34A",
  red: "#E11D48",
  gold: "#F59E0B",
  blue: "#2563EB",
  purple: "#7C3AED",
  orange: "#EA580C",
  pink: "#EC4899",
  white: "#E2E8F0",
};

export const HAIRS = [
  { id: "fade", label: "Fade" },
  { id: "afro", label: "Afro" },
  { id: "cornrows", label: "Cornrows" },
  { id: "braids", label: "Braids" },
  { id: "locs", label: "Dreads" },
  { id: "gele", label: "Gele" },
  { id: "durag", label: "Durag" },
  { id: "bald", label: "Bald" },
];

export const OUTFITS = [
  { id: "street", label: "Street" },
  { id: "ankara", label: "Ankara" },
  { id: "agbada", label: "Agbada" },
  { id: "owambe", label: "Owambe" },
  { id: "corporate", label: "Corporate" },
  { id: "jersey", label: "Jersey" },
];

export const ACCESSORIES = [
  { id: "none", label: "None" },
  { id: "cap", label: "Cap" },
  { id: "glasses", label: "Shades" },
  { id: "chain", label: "Gold Chain" },
  { id: "earring", label: "Earring" },
];

export const BODIES = [
  { id: "m", label: "Masc" },
  { id: "f", label: "Femme" },
];

export const DEFAULT_APPEARANCE = {
  body: "m",
  skin: "s2",
  hair: "fade",
  hairColor: "black",
  outfit: "street",
  outfitColor: "green",
  accessory: "none",
};

export function hexDarken(hex, amt = 0.2) {
  const h = hex.replace("#", "");
  const n = parseInt(h.length === 3 ? h.split("").map((c) => c + c).join("") : h, 16);
  let r = (n >> 16) & 255, g = (n >> 8) & 255, b = n & 255;
  r = Math.max(0, Math.round(r * (1 - amt)));
  g = Math.max(0, Math.round(g * (1 - amt)));
  b = Math.max(0, Math.round(b * (1 - amt)));
  return `#${((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1)}`;
}

export function normalizeAppearance(a) {
  if (!a || typeof a !== "object") return { ...DEFAULT_APPEARANCE };
  const pick = (val, map, def) => (val && map[val] !== undefined ? val : def);
  const inList = (val, list, def) => (list.some((x) => x.id === val) ? val : def);
  return {
    body: inList(a.body, BODIES, "m"),
    skin: pick(a.skin, SKINS, "s2"),
    hair: inList(a.hair, HAIRS, "fade"),
    hairColor: pick(a.hairColor, HAIR_COLORS, "black"),
    outfit: inList(a.outfit, OUTFITS, "street"),
    outfitColor: pick(a.outfitColor, OUTFIT_COLORS, "green"),
    accessory: inList(a.accessory, ACCESSORIES, "none"),
  };
}

// Deterministic look from a seed string — used for ambient NPC crowds.
export function seededAppearance(seed) {
  let h = 0;
  for (let i = 0; i < seed.length; i++) h = (h * 31 + seed.charCodeAt(i)) >>> 0;
  const skins = Object.keys(SKINS);
  const hairC = Object.keys(HAIR_COLORS);
  const outC = Object.keys(OUTFIT_COLORS);
  const r = (n) => { h = (h * 1103515245 + 12345) >>> 0; return h % n; };
  return {
    body: BODIES[r(BODIES.length)].id,
    skin: skins[r(skins.length)],
    hair: HAIRS[r(HAIRS.length)].id,
    hairColor: hairC[r(hairC.length)],
    outfit: OUTFITS[r(OUTFITS.length)].id,
    outfitColor: outC[r(outC.length)],
    accessory: ACCESSORIES[r(ACCESSORIES.length)].id,
  };
}
